import styled from '@emotion/styled';
import palette from 'theme/palette';

export const Badge = styled.div`
  background: ${palette.success.main};
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  min-width: 16px;
  padding: 0 2px;
  color: ${palette.common.white};
  position: absolute;
  top: 0;
  right: -2px;
`;
